import { render, staticRenderFns } from "./SubAccountsData.vue?vue&type=template&id=12fd09ea"
import script from "./SubAccountsData.vue?vue&type=script&lang=ts"
export * from "./SubAccountsData.vue?vue&type=script&lang=ts"
import style0 from "./SubAccountsData.vue?vue&type=style&index=0&id=12fd09ea&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports